export const FWA_COMPANY = {
  tradingName: "Fastener Warehouse Australia",
  legalName: "Capstone Assets Pty Ltd",
  abn: "96 664 679 814",
  phone: "1300 318 458",
  email: "accounts@fastenerwarehouse.com.au",
  website: "fastenerwarehouse.com.au",
};

export const FWA_BANK = {
  accountName: "Capstone Assets Pty Ltd T/As Fastener Warehouse Australia",
  bank: "CBA",
  bsb: "067-873",
  account: "1310 1816",
  remittanceEmail: "accounts@fastenerwarehouse.com.au",
};

export function hobsonSuffix(hobson_sales_order) {
  if (!hobson_sales_order) return "";
  const match = String(hobson_sales_order).match(/^[0-9]+([A-Za-z]*)$/);
  return match ? match[1] : "";
}

function formatAuDate(d) {
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
}

function dueDateFromInvoice(date, payment_method) {
  if (payment_method === "SQUARE") return "Paid";
  const duedate = new Date(date);
  if (Number.isNaN(duedate.getTime())) return "";
  duedate.setMonth(duedate.getMonth() + 1);
  duedate.setDate(1);
  duedate.setDate(duedate.getDate() + 29);
  if (duedate.getMonth() === 2 && duedate.getDate() > 28) {
    const year = duedate.getFullYear();
    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    duedate.setDate(isLeapYear ? 29 : 28);
  }
  return formatAuDate(duedate);
}

export function mapShipmentToFwaInvoice(data) {
  const suffix = hobsonSuffix(data.hobson_sales_order);
  const invoiceDate = data.shipment_date || data.date_added;
  const contact =
    data.name ||
    [data.firstname || data.first_name, data.lastname || data.last_name].filter(Boolean).join(" ");
  const street = [data.address_1, [data.city, data.state, data.postcode].filter(Boolean).join(" ")].filter(Boolean);
  return {
    number: (data.quote_code || "") + suffix,
    date: formatAuDate(invoiceDate),
    dueDate: dueDateFromInvoice(invoiceDate, data.payment_method),
    poNumber: data.po_number,
    paidByCard: data.payment_method === "SQUARE",
    terms: "30 days from end of month",
    billTo: {
      company: data.company,
      contact,
      address: street,
      email: data.email,
      phone: data.phone,
    },
    deliverTo: {
      name: data.company,
      address: street,
    },
    lines: (data.products || []).map((p) => ({
      code: p.hobson_part_number || p.hobson_part,
      description: p.hobson_description || p.description || p.name,
      qty: Number(p.hobson_quantity ?? p.quantity ?? 0),
      unitPrice: Number(p.price),
    })),
    freight: Number(data.shipping || 0),
    company: FWA_COMPANY,
    bank: FWA_BANK,
    termsUrl: "fastenerwarehouse.com.au/terms",
  };
}

export async function loadInvoiceLogoDataUrl() {
  try {
    const res = await fetch("/images/invoice-logo.png");
    if (!res.ok) return undefined;
    const blob = await res.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    return undefined;
  }
}
